import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";

const paths = createModuleRoutePaths({
  resource: ResourceEnum.Stock,
});
export const module: ModuleOptions = {
  resource: ResourceEnum.Stock,
  smallIcon: <i className="icon-15-inventory" />,
  bigIcon: <i className="icon-20-inventory" />,

  disableEdit: true,
  disableDelete: true,
  disableCreate: true,
  list: {
    routeObject: {
      path: paths.root,
      lazy: () =>
        import(
          "src/admin/modules/stock/components/StockModuleList/StockModuleList.tsx"
        ),
    },
  },
};
